import { Alert, Snackbar, Portal } from "@mui/material";

const NotificationBar = ({ open, setOpen, type, message }) => {
    return (
        <Portal>
            <Snackbar
                anchorOrigin={{
                    vertical: "center",
                    horizontal: "center",
                }}
                open={open}
                autoHideDuration={3000}
                onClose={() => setOpen(false)}
                sx={{
                    zIndex: 999999,
                }}
            >
                <Alert
                    onClose={() => setOpen(false)}
                    severity={type}
                    variant="filled"
                    sx={{
                        borderRadius: "12px",
                        fontSize: "12px",
                        fontWeight: 400,
                        backgroundColor: "#009E60 ",
                        color: "white",
                         }}
                >
                    {message}
                </Alert>
            </Snackbar>
        </Portal>
    );
};

export default NotificationBar;